import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddRequestButtonComponent } from './add-request-button/add-request-button.component';

@NgModule({
  declarations: [AddRequestButtonComponent],
  imports: [CommonModule],
  exports: [AddRequestButtonComponent]
})
export class AddRequestModule {}
